<template>
  <div class="return-receiving">
    <el-scrollbar ref="scroller" class="return-receiving-scroller">
      <dialog-table ref="dialog" :table-select="$tableSelect" :data="data" />
    </el-scrollbar>
  </div>
</template>

<script>
import DialogTable from '@utils/table-select/components/dialog-table'
import TableSelect from '@utils/table-select'
import Table from '@utils/table'
import Search from '@/utils/search'
import Select from './classifyNoList.vue'
import supplierGroups from './supplierGroups.vue'
import supplierStatus from './supplierStatus.vue'
import City from './supplierCity.vue'
import { $t } from '@/plugin/i18n'

const table = new Table('commonDialog')
  .sortable(false)
  .add('supplierNo')
  .add('supplierName')
  .add('classifyNoList')
  .add('supplierGroup')
  .add('status').label('supplierStatusName').html((data) => {
    switch (data.row.status) {
      case '1':
        return `<span><i style="display:inline-block;background-color: #6A35C9;width: 10px;height:10px;border-radius:2px;margin-right: 4px;"></i>${$t('cycleManagement.supplierMasterdata.potential')}</span>`
      case '2':
        return `<span><i style="display:inline-block;background-color: #2D71FB;width: 10px;height:10px;border-radius:2px;margin-right: 4px;"></i>${$t('cycleManagement.supplierMasterdata.cooperate')}</span>`
      case '3':
        return `<span><i style="display:inline-block;background-color: #DE0010;width: 10px;height:10px;border-radius:2px;margin-right: 4px;"></i>${$t('cycleManagement.supplierMasterdata.disuse')}</span>`
      case '4':
        return `<span><i style="display:inline-block;background-color: #2E72FB;width: 10px;height:10px;border-radius:2px;margin-right: 4px;"></i>${$t('cycleManagement.supplierMasterdata.qualified')}</span>`
      case '5':
        return `<span><i style="display:inline-block;background-color: #FFA743;width: 10px;height:10px;border-radius:2px;margin-right: 4px;"></i>${$t('cycleManagement.supplierMasterdata.strange')}</span>`
      case '6':
        return `<span><i style="display:inline-block;background-color: #FF7B23;width: 10px;height:10px;border-radius:2px;margin-right: 4px;"></i>${$t('cycleManagement.supplierMasterdata.frozen')}</span>`
      case '7':
        return `<span><i style="display:inline-block;background-color: #999999;width: 10px;height:10px;border-radius:2px;margin-right: 4px;"></i>${$t('cycleManagement.supplierMasterdata.blacklist2')}</span>`
      default:
        return ''
    }
  })
  .add('city')

const search = new Search('commonDialog')
  .placeholder('placeHolder')
  .add('supplierName').label('supplier').col(12)
  .add('classifyNoList').component(Select).attrs({ 'multiple': true }).col(12)
  .add('supplierGroups').label('supplierGroup').col(12).component(supplierGroups).attrs({ 'multiple': true })
  .add('statusList').label('supplierStatusName').col(12).component(supplierStatus).attrs({ 'multiple': true })
  .add('citys').label('city').col(12).component(City).attrs({ 'multiple': true })

const $tableSelect = new TableSelect()
  .type('page')
  .url('/examineAssessSystem/getExamineSupplierPage', process.env.VUE_APP_PURCHASE_API)
  .search(search)
  .dialogTable(table)
  .params(vm => {
    return { purchaseUnitNo: vm.data.purchaseUnitNo }
  })

export default {
  components: {
    DialogTable
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selection: []
    }
  },
  computed: {
    $tableSelect() {
      return $tableSelect
    }
  },
  mounted() {
    this.$refs.dialog.open()
  },
  methods: {
    validate() {
      this.selection = this.$refs.dialog.selection
      if (!this.selection.length) {
        this.$message.warning(this.$t('common.needSelection') || '')
      }
      return this.selection.length
    }
  }
}
</script>

<style lang="scss" scoped>
.return-receiving {
  margin: 0 -15px;
}
</style>
